import React, { createRef } from "react";
import { createPortal } from "react-dom";
import { autobind } from "lib/decorators";
import LuvitMovableSkyLight from "lib/components/LuvitMovableSkylightPortal";

const ESCAPE_KEY = 27;
const TAB_KEY = 9;

@autobind
export default class MovableModalPortal extends React.Component {
  constructor(props) {
    super(props);
    this.modalWrapperRef = createRef();
    this._handleKeyDown = this._handleKeyDown.bind(this);
    this._handleTab = this._handleTab.bind(this);
  }

  componentWillMount() {
    this.node = document.createElement("div");
    document.body.appendChild(this.node);
  }

  componentDidMount() {
    document.addEventListener("keydown", this._handleKeyDown);
    this.node.addEventListener("keydown", this._handleTab);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this._handleKeyDown);
    this.node.removeEventListener("keydown", this._handleTab);
    document.body.removeChild(this.node);
  }

  close() {
    this.props.close();
  }

  _handleKeyDown(event) {
    switch (event.keyCode) {
      case ESCAPE_KEY:
        this.close();
        break;
      default:
        break;
    }
  }

  _handleTab(event) {
    const { keyCode, shiftKey } = event;
    if (keyCode === TAB_KEY) {
      const focusableElements = this.node.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
      );
      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      if (!shiftKey && document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    }
  }

  render() {
    return createPortal(
      <LuvitMovableSkyLight
        initiallyOpen={true}
        {...this.props}
        ref={this.modalWrapperRef}
      >
        {this.props.children}
      </LuvitMovableSkyLight>,
      this.node,
    );
  }
}
